// Admin Imports
import Profile from "views/admin/adminSEttings";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdLock,
  MdOutlineToken,
  MdPerson,
  MdCurrencyBitcoin,
  MdOutlineFactory,
} from "react-icons/md";

import { FactorySettings } from "views/admin/factory";
import { Tokens } from "views/admin/tokens";
import { Pools } from 'views/admin/poolsList';

const routes = [
  {
    name: "Pools",
    layout: "/admin",
    path: "pools",
    icon: <MdOutlineToken className="h-6 w-6" />,
    component: <Pools />,
  },
  {
    name: "Tokens",
    layout: "/admin",
    path: "tokens",
    icon: <MdCurrencyBitcoin className="h-6 w-6" />,
    component: <Tokens />,
  },
  {
    name: "Factory Settings",
    layout: "/admin",
    path: "factory",
    icon: <MdOutlineFactory className="h-6 w-6" />,
    component: <FactorySettings />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
	{
    name: "Admin settings",
    layout: "/admin",
    path: "admin-settings",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
];
export default routes;
